import { ReactElement } from 'react'

import { NavigationSlates } from '@tribeplatform/gql-client/types'
import { SlateRenderer } from '@tribeplatform/slate-kit/components'

export const getNavigationComponents = (
  navigationSlates: NavigationSlates,
  additionalContext: Record<string, any>,
): {
  Header: ReactElement | null
  Sidebar1: ReactElement | null
  Sidebar2: ReactElement | null
  Footer: ReactElement | null
} => {
  const {
    header: headerSlate,
    sidebar1: sidebar1Slate,
    sidebar2: sidebar2Slate,
    footer: footerSlate,
  } = navigationSlates
  return {
    Header: headerSlate ? (
      <SlateRenderer
        slate={headerSlate}
        path={null}
        additionalContext={additionalContext}
      />
    ) : null,
    Sidebar1: sidebar1Slate ? (
      <SlateRenderer
        slate={sidebar1Slate}
        path={null}
        additionalContext={additionalContext}
      />
    ) : null,
    Sidebar2: sidebar2Slate ? (
      <SlateRenderer
        slate={sidebar2Slate}
        path={null}
        additionalContext={additionalContext}
      />
    ) : null,
    Footer: footerSlate ? (
      <SlateRenderer
        slate={footerSlate}
        path={null}
        additionalContext={additionalContext}
      />
    ) : null,
  }
}
